export const SEARCH_TYPES = ['search', 'searchAccounts', 'searchUser'];
export const SORT_TYPES = ['sortBy', 'sortByMyPlaylists'];

// do not render a mobile reset checkbox
export const NO_RESET_OPTION_FILTERS = ['language', 'sortBy', 'sortByMyPlaylists', 'assignedBy', 'myPlaylistsType'];
// replace the selected filter instead of adding them to the URL (multiple selection checkboxes)
export const SINGLE_OPTION_FILTERS = ['language', 'createdBy', 'assignedBy', 'sortBy', 'sortByMyPlaylists'];